<template>
  <span @mouseup="onMouseup" @click.stop><slot></slot></span>
</template>
<script setup>
import { pgMessage } from '../../message/index'

const emit = defineEmits(['click'])
const onMouseup = () => {
  setTimeout(() => {
    const text = window.getSelection
      ? window.getSelection().toString()
      : document.selection.createRange().text
    if (text) {
      document.execCommand('copy')
      pgMessage.success('复制成功')
    } else {
      emit('click')
    }
  })
}
</script>
